export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {bind} from 'kpc';
import type {MessageSendPayload} from 'kpc';

interface Props {
    value?: string
    suggestions?: string[]
}

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {
            value: '',
            suggestions: [
                '帮我总结这份会议纪要',
                '生成一段产品介绍',
                '解释一下 React Server Components',
            ],
        };
    }

    @bind
    pick(text: string) {
        this.set('value', text);
    }

    @bind
    onMessageSend(_payload: MessageSendPayload) {
        this.set('suggestions', []);
    }
}